import './i18n';
import './styles/app-base.css';
import './styles/app-components.css';
import './styles/app-utilities.css';
import { createRoot } from 'react-dom/client';
import App from './app/App';

// import * as serviceWorker from './serviceWorker';
// import reportWebVitals from './reportWebVitals';

// async function handleInitChat() {
// 	if (!driver || !warehouse) return dispatchAlert("error", trl("comms_paramsMissing"), 4000);
// 	const chatModel = new ChatMessage({ chat_id: params.get('chatId') });
// 	const id = await chatModel.getChatsId();
// 	id == "" ? appendToUri(`&chatId=${id}`) : appendToUri(`&chatId=${id}`);

// 	let url = process.env.NODE_ENV === 'development' ? `${appConfig.baseurl}${appConfig.socketChatBaseURL}` : appConfig.socketChatBaseURL;
// 	let socket = io(url, {
// 		auth: { chat_id: chatId, shipment },
// 		transports: ['websocket'],
// 		reconnectionAttempts: 5,
// 		reconnectionDelay: 1000,
// 		reconnection: true,
// 		timeout: 20000,
// 		upgrade: false
// 	});

// 	socket.on('connect', async () => {
// 		console.log("socket initialized", { connected: socket?.connected })
// 		useSocketStore.setState({ messageSocket: socket });
// 		// handleFetchMessages(socket);
// 		setIsConnected(true);
// 	});
// 	socket.on('disconnect', (reason) => {
// 		console.log("socket disconnected", { reason })
// 	});
// }

/**
 * The root element of the application.
 */
const container = document.getElementById('root');


if (!container) {
	throw new Error('Failed to find the root element');
}

/**
 * The root component of the application.
 */
const root = createRoot(container);

root.render(<App />);

// reportWebVitals();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
// serviceWorker.unregister();
